import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-promotion-code',
    templateUrl: './promotion-code.component.html',
    styleUrls: ['./promotion-code.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PromotionCodeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}
